"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * SolutionForAgenciesAndFreelancers — Section 6: 4-Step Workflow
 * Drop-in für: src/pages/SolutionForAgenciesAndFreelancers/sections/Ablauf.tsx
 */

const steps = [{
  number: "1",
  title: "Kunde beschreibt sein Business",
  description: "Im Erstgespräch erfassen Sie Branche, Wünsche und Ziele. Das reicht als Briefing für die KI."
}, {
  number: "2",
  title: "KI erstellt die Website",
  description: "In wenigen Minuten generiert der AI Builder eine vollständige Website — mit Texten, Bildern und Layout."
}, {
  number: "3",
  title: "Sie passen an und verfeinern",
  description: "Farben, Bilder, Texte — alles im Drag-and-Drop-Editor. Passen Sie die Website auf den Kunden an."
}, {
  number: "4",
  title: "Publizieren und verrechnen",
  description: "Ein Klick — die Seite ist live. Sie verrechnen dem Kunden Ihr eigenes Paket. Ihre Marge bleibt bei Ihnen."
}];
export default function Ablauf() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-5xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Ihr neuer Workflow
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Vom Kundengespräch zur fertigen Website in 4 Schritten.
          </p>
        </div>

        <div className="space-y-6 md:space-y-8">
          {steps.map(s => <div key={s.number} className="flex items-start gap-5 md:gap-6 bg-background border border-border rounded-xl p-5 md:p-6">
              <div className="size-11 md:size-12 shrink-0 rounded-full bg-primary text-white flex items-center justify-center text-lg font-bold shadow-lg shadow-primary/20">
                {s.number}
              </div>
              <div className="flex-1 pt-1">
                <h3 className="text-lg md:text-xl font-bold text-foreground mb-1.5 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-base text-muted-foreground leading-relaxed">
                  {s.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}